import { Component, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SharedModule } from '../../../_shared/shared.module';

import { User } from '../../shared/user.model';

@Component({
  selector: 'app-users-info-modal',
  templateUrl: './users-info-modal.component.html',
  standalone: true,
  imports: [SharedModule],
})
export class UsersInfoModalComponent {
  modalTitle = this.data.title;
  users: User[] = this.data.obj;

  constructor(
    private ref: MatDialogRef<UsersInfoModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data
  ) {}

  close() {
    this.ref.close();
  }
}
